import { useReducer, useState } from 'react';

import { initialInsuranceState, insuranceReducer } from './insuranceReducer';
import InsuranceForm from './insuranceForm';

const AddInsurance = () => {
	const [insuranceInfo, setInsuranceInfo] = useReducer(insuranceReducer, initialInsuranceState);
	const [branchIds, setBranchIds] = useState<string[]>([]);

	const createInsuranceHandler = async () => {
		if (!insuranceInfo.name) return;

		// setSaving(true);
		// try {
		//   // Create the payload
		//   const createPayload = {
		//     ...insuranceInfo,
		//     branchIds,
		//   };

		//   await InsuranceAPI.createInsurance(createPayload);

		//   // Navigate back to insurances list
		//   navigate("/admin/insurances");
		// } catch (error: any) {
		//   errorNormalizer(error);
		// } finally {
		//   setSaving(false);
		// }
	};

	return (
		<InsuranceForm
			insuranceInfo={insuranceInfo}
			setInsuranceInfo={setInsuranceInfo}
			saveInsuranceHandler={createInsuranceHandler}
			branchIds={branchIds}
			onBranchChange={setBranchIds}
		/>
	);
};

export default AddInsurance;
